module.exports = __webpack_public_path__ + "static/media/website.6adb4c09.svg";